import { useStore } from 'vuex'

export default {
    name: "MitIdLogout",
    setup(){
        const store = useStore()

        const logout = () => {
            store.dispatch('mitid/logout')
            .then((_) => {
                window.location.reload()
            })
        }

        return {
            logout
        }
    }
}